import {
  RCU_CMDTYPE,
  RCU_GROUP,
  RCU_TOP_TYPE,
  RELAY_NUMBERING,
} from '../../catalog/protocol';
import type { RelayValue } from '../../catalog/protocol';
import type { Result } from '../../result';
import type { RcuDocument } from '../../wire';
import { fieldRange, validated } from './validate';

/** Onboard relays: relays 1–26, addressed in a group. */
export interface RelayRefInput {
  readonly group: number;
  readonly relay: number;
}

export interface OperateRelayInput extends RelayRefInput {
  /** `RELAY_VALUE`: 0 off, 1 on, 2 toggle, 4 bell. */
  readonly value: RelayValue;
}

const relayRefChecks = (input: RelayRefInput): readonly ReturnType<typeof fieldRange>[] => [
  fieldRange('Group', input.group, RCU_GROUP.MIN, RCU_GROUP.MAX),
  fieldRange('Relay', input.relay, RELAY_NUMBERING.FIRST, RELAY_NUMBERING.LAST),
];

export const operateRelay = (input: OperateRelayInput): Result<RcuDocument> =>
  validated(
    {
      type: RCU_TOP_TYPE.COMMAND,
      data: {
        cmdtype: RCU_CMDTYPE.OPERATE_RELAY,
        groupid: input.group,
        relayno: input.relay,
        value: input.value,
      },
    },
    relayRefChecks(input),
  );

/** Reads stored state, not the contact: a missing value reads as zero. */
export const readRelay = (input: RelayRefInput): Result<RcuDocument> =>
  validated(
    {
      type: RCU_TOP_TYPE.COMMAND,
      data: { cmdtype: RCU_CMDTYPE.READ_RELAY, groupid: input.group, relayno: input.relay },
    },
    relayRefChecks(input),
  );

/** Reads all 26 relays in one reply. */
export const readAllRelays = (): Result<RcuDocument> =>
  validated({ type: RCU_TOP_TYPE.COMMAND, data: { cmdtype: RCU_CMDTYPE.READ_ALL_RELAYS } });
